import { useCanvasBridge } from '@hooks/useCanvasBridge'

/**
 * The embedded game canvas (iframe). Global + game-agnostic: only the URL
 * changes per game (resolved from `gameCode` inside the bridge). All FE⇄canvas
 * communication lives in `useCanvasBridge`; this component is just the frame.
 */
const GameCanvas = () => {
  const { iframeRef, onLoad } = useCanvasBridge()

  // No `src` here on purpose — the bridge assigns it imperatively only after its
  // message listener is attached, so the canvas' BOOT handshake is never missed.
  return (
    <div className="game-canvas-outer-container">
      <div className="game-canvas-inner-container">
        <iframe
          ref={iframeRef}
          onLoad={onLoad}
          title="game-canvas"
          className="game-canvas-iframe"
          allow="autoplay"
        />
      </div>
    </div>
  )
}

export default GameCanvas
